export default __webpack_public_path__ + "static/avatar-kayi-common-1-detail-cd4ec43f3583ad7a1686107788da0fb5.png";